/**
 * Role Permissions Service
 * Super-admin matrix endpoints (CASL-backed RBAC).
 */

import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';
import type { RoleName } from '@/stores/permissions.store';

export interface RolePermissionsItem {
	role: RoleName;
	permissions: string[];
	updatedBy?: string;
	updatedAt?: string;
}

export interface RolePermissionsMatrix {
	roles: RoleName[];
	catalog: string[];
	items: RolePermissionsItem[];
}

export const rolePermissionsService = {
	async getAll(): Promise<RolePermissionsMatrix> {
		const response = await api.get<ApiResponse<RolePermissionsMatrix>>(
			API_ENDPOINTS.ROLE_PERMISSIONS.BASE
		);
		return response.data.data;
	},

	async getByRole(role: RoleName): Promise<RolePermissionsItem> {
		const response = await api.get<ApiResponse<RolePermissionsItem>>(
			API_ENDPOINTS.ROLE_PERMISSIONS.BY_ROLE(role)
		);
		return response.data.data;
	},

	async updateRole(role: RoleName, permissions: string[]): Promise<RolePermissionsItem> {
		const response = await api.put<ApiResponse<RolePermissionsItem>>(
			API_ENDPOINTS.ROLE_PERMISSIONS.BY_ROLE(role),
			{ permissions }
		);
		return response.data.data;
	}
};
